export const mimeTypeHasPreview = (mimeType: string) =>
  /((image|video|audio)\/([0-9A-Za-z!#$%&'*+.^_`|~-]+)|(application\/pdf))/.test(
    mimeType,
  );

export const getPublicUrl = (token: string) =>
  `${window.location.origin}/shared-content/${token}`;

export const FILE_TYPE_OPTIONS = [
  'folder',
  'txt',
  'zip',
  'audio',
  'image',
  'video',
  'word',
  'excel',
  'powerpoint',
  'pdf',
  'photoshop',
  'illustrator',
];
